import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './pages/home/Home')
    },
    {
      path: '/consulta/:Chave',
      name: 'consulta',
      component: () => import(/* webpackChunkName: "consulta" */ './pages/home/Consulta')
    },
    {
      path: '/teste/:Param1',
      name: 'teste',
      component: () => import(/* webpackChunkName: "teste" */ './pages/home/teste')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './pages/login/Login')
    }
  ]
})
